import { useAppNavigation } from 'hooks/common/useAppNavigation';
import { EQUIPMENT_EDIT_TAB_STATE_KEY } from 'pages/AssetManagement/containers/EquipmentRegistry/constants/tabs';
import { openInNewWindow } from 'utils/v1.1/openInNewWindow';

const BASE_PATH = '/asset-management';
export const BASE_EQUIPMENT_QR_PATH = `${BASE_PATH}/equipment/qr-scan`;

export const ARCHIVED_ASSET_TYPE_PATH = `${BASE_PATH}/asset-type/archived`;

export const useAssetManagementNavigation = () => {
  const { navigateTo, goBack } = useAppNavigation();

  return {
    goBack,

    // Equipments
    goToEquipmentRegistryListPage: () => navigateTo(`${BASE_PATH}/equipment/`),
    goToRegisterEquipmentPage: () =>
      navigateTo(`${BASE_PATH}/equipment/register/`),
    goToEquipmentDetailPageFromQRScan: (equipmentId: string) =>
      navigateTo(`${BASE_EQUIPMENT_QR_PATH}/${equipmentId}`),
    goToEquipmentDetailPage: (equipmentId: string) =>
      navigateTo(`${BASE_PATH}/equipment/${equipmentId}/`),
    goToEquipmentQRScanPage: (equipmentId: string) =>
      navigateTo(`${BASE_PATH}/equipment/qr-scan/${equipmentId}`),
    goToEditEquipmentPage: (equipmentId: string, tab?: number) => {
      const path = `${BASE_PATH}/equipment/edit/${equipmentId}`;
      if (tab === undefined || tab === 0) {
        navigateTo(path);
        return;
      }
      navigateTo(`${path}?tab=${tab}`, {
        state: { [EQUIPMENT_EDIT_TAB_STATE_KEY]: tab },
      });
    },
    goToArchivedEquipmentPage: () =>
      navigateTo(`${BASE_PATH}/equipment/archived`),

    goToEquipmentDetailPageInNewTab: (equipmentId: string) =>
      openInNewWindow(`${BASE_PATH}/equipment/${equipmentId}/`),

    // Attachments
    goToAttachmentListPage: () => navigateTo(`${BASE_PATH}/attachment/`),
    goToAttachmentAddPage: () => navigateTo(`${BASE_PATH}/attachment/add/`),
    goToAttachmentEditPage: (attachmentId: string) =>
      navigateTo(`${BASE_PATH}/attachment/edit/${attachmentId}`),
    goToAttachmentDetailPage: (attachmentId: string) =>
      navigateTo(`${BASE_PATH}/attachment/${attachmentId}/`),
    goToArchivedAttachmentPage: () =>
      navigateTo(`${BASE_PATH}/attachment/archived`),

    goToAttachmentDetailPageInNewTab: (attachmentId: string) =>
      openInNewWindow(`${BASE_PATH}/attachment/${attachmentId}/`),

    // Asset Types
    goToAssetTypeListPage: () => navigateTo(`${BASE_PATH}/asset-type/`),
    goToArchivedAssetTypePage: () => navigateTo(ARCHIVED_ASSET_TYPE_PATH),

    // Asset Import
    goToAssetImportPage: () => navigateTo(`${BASE_PATH}/asset-import`),
  };
};
